export const loadWhenIdle = (fn) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(fn, { timeout: 4000 });
  } else {
    // very old Safari / Firefox fallback
    setTimeout(fn, 2000);
  }
};